import React, { useRef, useState } from 'react';
import AI from '../assets/ai.mp4'
export default function FullScreenVideo() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="position-relative" style={{ height: '100vh', width: '100%', overflow: 'hidden', backgroundColor: '#000' }}>
      <style>
        {`
         
          
          .video-container {
            height: 100vh;
            width: 100%;
            position: relative;
            overflow: hidden;
          }
          
          .fullscreen-video {
            width: 100%;
            height: 100vh;
            object-fit: cover;
            display: block;
          }
          
          .video-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.3) 100%);
            pointer-events: none;
          }
          
          .video-controls {
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 10;
          }
          
          .play-button {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.9);
            border: none;
            cursor: pointer;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 4px 15px rgba(0,0,0,0.3);
          }
          
          .play-button:hover {
            background: rgba(255, 255, 255, 1);
            transform: scale(1.1);
          }
          
          .content-overlay {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            color: white;
            z-index: 5;
            text-shadow: 2px 2px 10px rgba(0,0,0,0.7);
          }
        `}
      </style>

      <div className="video-container">
        <video
          ref={videoRef}
          className="fullscreen-video"
          loop
          muted
          playsInline
          autoPlay
        >
          <source
            src={AI}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>

        <div className="video-overlay"></div>

        <div className="content-overlay">
          <h1 className="display-3 fw-bold mb-3">Build AI with us</h1>
          
        </div>

        <div className="video-controls">
          <button
            className="play-button"
            onClick={togglePlay}
            aria-label={isPlaying ? 'Pause' : 'Play'}
          >
            {isPlaying ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="6" y="4" width="4" height="16" fill="currentColor" stroke="none"/>
                <rect x="14" y="4" width="4" height="16" fill="currentColor" stroke="none"/>
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <polygon points="8,5 19,12 8,19" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}